export var ProductType;
(function (ProductType) {
    ProductType["Consumable"] = "Consumable";
    ProductType["Subscription"] = "Subscription";
})(ProductType || (ProductType = {}));
//# sourceMappingURL=product-type.const.js.map